import { Grid, Typography, Box } from "@mui/material";
import PropTypes from "prop-types";

interface Props {
  Icon: React.ElementType;
  statisticTitle: string;
  statisticFigure: number | null;
}

export const StatisticsCard: React.FC<Props> = ({
  Icon,
  statisticFigure,
  statisticTitle,
}) => {
  const getColors = () => {
    switch (statisticTitle) {
      case "Total books":
        return { boxBgcolor: "#007AFF1A", iconColor: "#007AFF" };

      case "Books completed":
        return { boxBgcolor: "#4BA6631A", iconColor: "#4BA663" };

      case "Books in Progress":
        return { boxBgcolor: "#FEF3C7", iconColor: "#D97706" };

      case "Books Delivered":
        return { boxBgcolor: "#5856D61A", iconColor: "#5856D6" };

      case "Monthly Progress":
        return { boxBgcolor: "#8000801A", iconColor: "#800080" };
    }
  };
  return (
    <Grid
      size={2.4}
      sx={{
        backgroundColor: "background.paper",
        padding: 1,
        paddingTop: 2,
        paddingBottom: 2,
        borderRadius: 1,
        display: "flex",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          width: 40,
          height: 40,
          borderRadius: 30,
          backgroundColor: getColors()?.boxBgcolor,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginRight: 2,
        }}
      >
        <Icon sx={{ width: 30, height: 30, color: getColors()?.iconColor }} />
      </Box>

      <Box>
        <Typography variant="body1" sx={{ fontSize: 20, fontWeight: 600 }}>
          {statisticFigure}
        </Typography>
        <Typography variant="body1" fontSize={12}>
          {statisticTitle}
        </Typography>
      </Box>
    </Grid>
  );
};

StatisticsCard.propTypes = {
  Icon: PropTypes.elementType.isRequired,
  statisticTitle: PropTypes.string.isRequired,
  statisticFigure: PropTypes.number,
};
